module.exports = __webpack_public_path__ + "img/hbg_export_syj.781e20d7.png";